module.exports = __webpack_public_path__ + "static/media/icon-new-arrow-back.684a95c9.svg";